import React, { useEffect, useState } from "react";
import { GridInformative, ButtonHLPure, SimpleLoading } from "../../pures";
import { Grid } from "@material-ui/core";
import { LocalStorageService, RepseService } from "../../../services";

const RepseStatusByDocumentsView = (props) => {
  // const { onMonthSelected, yearShown, selectedContract, monthNumber, month, selectedYear } = props
  const {onMonthSelected, selectedContract, month, selectedYear, selectedMonthNumber } = props
  const localStorageService = new LocalStorageService()
  const repseService = new RepseService(process.env.REACT_APP_MIFIRMA_API)
  const [documents, setDocuments] = useState()


  const getData = async () => {
    let token = localStorageService.getLocalStorageItem('token').idToken
    let response = await repseService.getDocuments(selectedContract.id, selectedYear, selectedMonthNumber, token)
    // let response = await repseService.getDocuments(selectedContract.contractorId, 2023, 8, token)
    if (response.statusCode === 200) {
      setDocuments(response.data)
    } else {
      setDocuments([])
    }
  }
  useEffect(() => {
    getData()
  }, [])

  return (
    <div className="fadeIn">
      {!documents ? <SimpleLoading /> :
        <div>
          <Grid>
            <p className="column-title" style={{ fontWeight: "bold" }}>Servicios de limpieza, documentos del {month}-{selectedYear}</p>
          </Grid>
          <GridInformative
            dataItems={documents}
          />
          <Grid className="repseStatusByCompany-actionsContainer">
            <div className="justify-right">
              <ButtonHLPure nameBtn={"Regresar"} onClickBtn={() => onMonthSelected(false, 0, "")} />
            </div>
          </Grid>
        </div>}
    </div>
  );
};

export default RepseStatusByDocumentsView;
